export default __webpack_public_path__ + "static/media/2008.64198490.png";